/**
 * «🔥 Ближайшие сроки ответа» — `div.deadline-list#hotBlock` (ui-blocks.md §5.5).
 *
 * Топ-10 открытых дел по сроку ответа. Строка со сроком ≤ 3 дней (включая
 * просроченные) подсвечивается `urgent-row`. Клик — карточка дела.
 * Суммы денежных требований в данных нет (DECISIONS.md), поэтому
 * `.item-amount` из макета не выводится.
 */

import type { KeyboardEvent } from 'react';
import { caseWord, deadlineClass, stageLabel } from './format';
import type { CaseListItem, HotBlock, OpenCase } from './types';

interface Props {
    hot: HotBlock;
    openCase: OpenCase;
}

export function HotList({ hot, openCase }: Props) {
    const onKeyDown = (event: KeyboardEvent<HTMLDivElement>, item: CaseListItem): void => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openCase(item.case_id);
    };

    return (
        <div className="deadline-list" id="hotBlock">
            <div className="list-header">
                <h3>🔥 Ближайшие сроки ответа</h3>
                <span className="count" id="hotCount">
                    {hot.total_open} {caseWord(hot.total_open)} в работе
                </span>
            </div>
            <div id="hotList">
                {hot.rows.length === 0 ? (
                    <div className="detail-empty">Открытых дел нет — новые появятся здесь после разбора входящих.</div>
                ) : (
                    hot.rows.map((item) => {
                        const left = item.days_left;
                        const urgent = left !== null && left <= 3;
                        const icon = item.priority === 1 ? '🚨' : '📌';
                        return (
                            <div
                                key={item.case_id}
                                className={urgent ? 'deadline-item urgent-row' : 'deadline-item'}
                                data-case={item.case_id}
                                tabIndex={0}
                                role="button"
                                onClick={() => openCase(item.case_id)}
                                onKeyDown={(event) => onKeyDown(event, item)}
                            >
                                <span className="item-desc">
                                    {icon} {item.title}
                                    {item.escalation_risk && <span title="риск проверки"> 🛡</span>}
                                </span>
                                <span className="item-meta">
                                    <span className={`stage-chip s-${item.stage}`}>
                                        {stageLabel(item.stage)}
                                    </span>
                                    <span className={`item-date ${deadlineClass(item.deadline_state)}`.trim()}>
                                        {item.deadline_text}
                                    </span>
                                    <span className="item-responsible">
                                        👤 {item.executor_name ?? '—'}
                                    </span>
                                </span>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}
